import {
    Box,
    Button,
    FormControl,
    Grid,
    Hidden,
    IconButton,
    InputAdornment,
    makeStyles,
    Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { connect } from "react-redux";
import history from "../../../services/history";
import axios, { setToken } from "../../../http-common";
import * as AuthActions from "../../../actions/auth";
import * as SnackMensajeActions from "../../../actions/snackMensaje";

import logoGaleno from "../../../assets/img/logo-galeno.png";
import ingresoImagen from "../../../assets/img/ingresar.jpg";
import { TextFieldCustom } from "../../common/UI/Personalizaciones/TextField";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import styles from "./styles";
const useStyles = makeStyles(styles);

function LogIn(props) {
    const classes = useStyles();

    const [user, setUser] = useState({ name: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({ name: "", password: "" });

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleChange = (event) => {
        if (!!errors[event.target.name]) {
            setErrors({ ...errors, [event.target.name]: "" });
        }
        setUser({ ...user, [event.target.name]: event.target.value });
    };

    const ingresar = () => {
        // validaciones
        if (!user.name)
            setErrors((prevErrors) => ({
                ...prevErrors,
                name: "Ingrese un número válido",
            }));
        if (!user.password)
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: "Ingrese una contraseña válida",
            }));
        if (!user.name || !user.password) return;
        //
        let data = new FormData();
        data.append("username", user.name);
        data.append("password", user.password);
        axios
            .post("prestadores/login", data, { headers: {} })
            .then((response) => {
                const token = response.data;
                setToken(token);
                props.setToken(token);
                props.getInformacionUsuario();
                history.push("/");
            })
            .catch((error) => {
                const mensajeConfig = {
                    mostrarSnack: true,
                    mensajeSnack: "Credenciales inválidas",
                };
                props.actualizarAtriutoSnackMensaje(mensajeConfig);
            });
    };

    return (
        <Grid container>
            <Grid item xs={12} md={6} className={classes.formContainer}>
                <Box className={classes.appBar}>
                    <img src={logoGaleno} alt="Logo" className={classes.logo} />
                    <Typography display="inline" align="right">
                        Inicio de sesión de prestadores
                    </Typography>
                </Box>
                <Grid container className={classes.contenidoPrincipal}>
                    <Grid item xs={1} sm={2} md={3}></Grid>
                    <Grid item xs={10} sm={8} md={6}>
                        <Typography className={classes.title}>
                            ¡Bienvenido a Galeno!
                        </Typography>
                        <FormControl fullWidth className={classes.form}>
                            <TextFieldCustom
                                id="name"
                                name="name"
                                label="Número o usuario"
                                variant="outlined"
                                value={user.name}
                                error={!!errors.name}
                                helperText={errors.name}
                                onChange={(event) => handleChange(event)}
                            />
                        </FormControl>
                        <FormControl fullWidth className={classes.form}>
                            <TextFieldCustom
                                id="password"
                                name="password"
                                label="Contraseña"
                                variant="outlined"
                                type={showPassword ? "text" : "password"}
                                value={user.password}
                                error={!!errors.password}
                                helperText={errors.password}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={
                                                    handleClickShowPassword
                                                }
                                                onMouseDown={
                                                    handleMouseDownPassword
                                                }
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={handleChange}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.form}
                                onClick={ingresar}
                            >
                                Ingresá
                            </Button>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Hidden smDown>
                <Grid item xs={12} md={6} className={classes.imagen}>
                    <img src={ingresoImagen} alt="" />
                </Grid>
            </Hidden>
        </Grid>
    );
}

const mapDispatchToProps = {
    setToken: AuthActions.setToken,
    getInformacionUsuario: AuthActions.getInformacionUsuario,
    actualizarAtriutoSnackMensaje:
        SnackMensajeActions.actualizarAtriutoSnackMensaje,
};

export default connect(null, mapDispatchToProps)(LogIn);
